module.exports = __webpack_public_path__ + "img/disabled_program_pulih.e40d72a3.png";